import { Typography } from "@material-ui/core"


const Miss = (props) => {

  return ( <>
    <Typography>
      We’ll miss you, but the show must go on! When you purchase your song, you will fill out some basic details about what you want. If you miss your scheduled session, our lyricists will craft the first draft of your lyrics based on that information instead of a live conversation. Of course, you’ll still have the chance to request revisions—so while we’d love to chat, your song is still in good hands!
    </Typography>
  </> )
}

export default Miss
